import { connect } from 'react-redux';
import { resetErrorAction } from 'services/store/base/actions';
import {
  userUpdate,
  userDelete,
  userActionNames,
} from 'services/store/user/actions';
import {
  checkErrorSelector,
  checkLoadingSelector,
  checkSuccessSelector,
} from 'services/store/base/selectors';
import Overview from './Overview';

const mapStateToProps = ({
  // @ts-ignore
  base,
  // @ts-ignore
  user,
}) => ({
  user,
  isUpdateLoading: checkLoadingSelector(base, [userActionNames.USER_UPDATE]),
  updateError: checkErrorSelector(base, [userActionNames.USER_UPDATE]),
  updateSucceeded: checkSuccessSelector(base, [userActionNames.USER_UPDATE]),

  isDeleteLoading: checkLoadingSelector(base, [userActionNames.USER_DELETE]),

  deleteError: checkErrorSelector(base, [userActionNames.USER_DELETE]),
});
const mapDispatchToProps = (
  // @ts-ignore
  dispatch
) => ({
  userUpdate: (
    // @ts-ignore
    userId,
    // @ts-ignore
    userData
  ): void => {
    dispatch(userUpdate({ id: userId, user: userData }));
  },
  userDelete: (
    // @ts-ignore
    userId
  ): void => {
    dispatch(userDelete({ id: userId }));
  },
  resetDeleteError: (): void => {
    dispatch(resetErrorAction({ type: userActionNames.USER_DELETE }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  // @ts-ignore
  Overview
);
